import { Dialog } from "primereact/dialog";
import React, { useState, useRef, useEffect } from "react";
import { observer } from "mobx-react";
import { MailerModalModel } from "./types/MailerModalModel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";
import { ContactInformation } from "./types/ContactInformation";
import { Button } from "primereact/button";
import { LabelPrinter } from "utils/Globals";
import { Message } from "components/MessageSummary/Message";
import { MessageSummary } from "components/MessageSummary/MessageSummary";

import "./types/Case.scss";

export const MailerModal: React.FC<MailerModalModel> = observer(function (props) {
    const [contacts, setContacts] = useState([] as ContactInformation[]);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedContacts, setSelectedContacts] = useState([] as ContactInformation[]);
    const [message, setMessage] = useState<Message>(null);

    const dt = useRef<DataTable>(null);

    useEffect(() => {
        const getContacts = async () => {
            const response = await axios.get<ContactInformation[]>(`Case/GetCaseContactInformationByCaseId?caseId=${props.caseId}`);
            setContacts(response.data ?? []);
        };

        getContacts();
    }, [props.caseId]);

    window.Frontend.MailerModalShow = () => setShowDialog(true);

    const onDialogHide = () => {
        setShowDialog(false);
        setSelectedContacts(null);
    };

    const printMailer = async () => {
        var response = await axios.post<string>("Case/PrintContactMailer", selectedContacts);
        setSelectedContacts(null);
        setShowDialog(false);

        window.open(`Report/Show?id=${response.data}`, "_blank");
    };

    const printMailerLabels = async () => {
        const labelPrinter = new LabelPrinter({
            templateName: "MailerTemplate",
            onReady: () => {
                for (const contact of selectedContacts) {
                    const data = {
                        Address: `${contact.ContactFullName}\n${contact.NewLineFullAddress}`.replace(/(\r\n|\r)/g, '\n')
                    }

                    labelPrinter.printLabel({ data: data });
                }
            },
            onError: (error: any) => {
                setMessage({
                    detail: error,
                    severity: "error",
                    toastify: false,
                    sticky: true
                });
            }
        });
    };

    const footer = () => {
        const canPrint = selectedContacts?.length > 0 && !message;

        return (
            <div className="p-d-flex p-ai-center">
                <Button
                    type="button"
                    icon="pi pi-print"
                    iconPos="left"
                    label="Print"
                    onClick={printMailer}
                    disabled={!canPrint}
                />
                {props.enableLabelPrinting &&
                    <Button
                        type="button"
                        icon="pi pi-print"
                        iconPos="left"
                        label="Print Labels"
                        onClick={printMailerLabels}
                        disabled={!canPrint}
                    />
                }
            </div>
        );
    };

    const addressBodyTemplate = (rowData: ContactInformation) => {
        if (rowData.CommaFullAddress?.trim()) {
            return <span>{rowData.CommaFullAddress}</span>;
        } else {
            return <span className="no-address">Address missing or not found</span>;
        }
    };

    return (
        <div>
            <Dialog
                header="Mailers"
                style={{ width: "65vw", height: "65vh", overhlow: "hidden" }}
                visible={showDialog}
                onHide={onDialogHide}
                footer={footer}
            >
                <MessageSummary message={message} onRemove={() => setMessage(null)} />
                <div style={{ float: "left", width: "100%", height: "100%" }}>
                    <DataTable
                        value={contacts}
                        size="small"
                        emptyMessage="No Contacts"
                        showGridlines={false}
                        scrollable
                        ref={dt}
                        rowHover
                        selection={selectedContacts}
                        onSelectionChange={(e) => setSelectedContacts(e.value)}
                        sortMode="multiple"
                    >
                        <Column selectionMode="multiple" headerStyle={{ maxWidth: "50px" }} bodyStyle={{ maxWidth: "50px" }}></Column>
                        <Column field="ContactFullName" header="Contact Name" sortable></Column>
                        <Column field="CommaFullAddress" header="Contact Address" body={addressBodyTemplate} sortable></Column>
                        <Column field="ContactCategory" header="Contact Category" sortable>{" "}</Column>
                    </DataTable>
                </div>
            </Dialog>
        </div>
    );
});
